<template>
    <span class="label label-info" style="padding:.1em .5em .2em;margin-left:3px;margin-right:3px;">{{to}}</span>
</template>

<script>
export default {
    props: ['to']
}
</script>




// WEBPACK FOOTER //
// src/components/elements/label.vue